module.exports = __webpack_public_path__ + "img/icon-192x192.40f00630.png";